import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
// @ts-ignore next
import { AdcHeader } from '@adc/ui-adc';
import { ProductLine } from '@adc/constants';
import classnames from 'classnames/bind';
import { getWebComponentName, getTheme, getEmbeddedContext } from '../utils';
import { useUserAndFlags } from '../hooks/useUserAndFlags';
// @ts-ignore next
import styles from '../base.scss';
const cx = classnames.bind(styles);
const SMARTSALE_AUTHENTICATED_LANDING_ROUTE = '/dashboard/seller';
const WrappedComponent = props => {
    const { user, featureFlags } = useUserAndFlags();
    // The returnUrl is used to redirect the user after login/signup... redirect to seller (my listings) if smart sale
    const returnUrl = getTheme().productLine === ProductLine.SmartSale
        ? SMARTSALE_AUTHENTICATED_LANDING_ROUTE
        : encodeURIComponent(window.location.href);
    return (React.createElement(AdcHeader, { style: { zIndex: 1000 }, ...props, theme: getTheme(), featureFlags: featureFlags, user: user, onLoginClick: () => {
            window.location.href = `/login?back=${returnUrl}`;
        }, onSignupClick: () => {
            window.location.href = `/signup?back=${returnUrl}`;
        }, className: cx('component-root'), embeddedContext: getEmbeddedContext() }));
};
const WebComponent = r2wc(WrappedComponent, {
    props: {
        showSearch: 'boolean',
        showLinks: 'boolean',
        dropdownStyle: 'string',
    },
});
customElements.define(getWebComponentName('header'), WebComponent);
